var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEnable2Fa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 204,
    height: 124,
    viewBox: "0 0 204 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M164.513 6.69232C162.298 6.69232 160.497 4.89095 160.497 2.6765C160.497 1.93726 159.898 1.33789 159.158 1.33789C158.418 1.33789 157.82 1.93726 157.82 2.6765C157.82 4.89095 156.018 6.69232 153.804 6.69232C153.064 6.69232 152.465 7.29169 152.465 8.03093C152.465 8.77017 153.064 9.36954 153.804 9.36954C156.018 9.36954 157.82 11.1709 157.82 13.3854C157.82 14.1246 158.418 14.724 159.158 14.724C159.898 14.724 160.497 14.1246 160.497 13.3854C160.497 11.1709 162.298 9.36954 164.513 9.36954C165.253 9.36954 165.851 8.77017 165.851 8.03093C165.851 7.29169 165.253 6.69232 164.513 6.69232Z",
    fill: "#86C1D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M180.576 22.7548C178.361 22.7548 176.56 20.9535 176.56 18.739C176.56 17.9998 175.961 17.4004 175.221 17.4004C174.482 17.4004 173.883 17.9998 173.883 18.739C173.883 20.9535 172.082 22.7548 169.867 22.7548C169.127 22.7548 168.528 23.3542 168.528 24.0934C168.528 24.8327 169.127 25.432 169.867 25.432C172.082 25.432 173.883 27.2334 173.883 29.4479C173.883 30.1871 174.482 30.7865 175.221 30.7865C175.961 30.7865 176.56 30.1871 176.56 29.4479C176.56 27.2334 178.361 25.432 180.576 25.432C181.316 25.432 181.915 24.8327 181.915 24.0934C181.915 23.3542 181.316 22.7548 180.576 22.7548Z",
    fill: "#86C1D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2055 105.753V29.131C16.2055 24.8528 17.7185 20.7498 20.4116 17.7247C23.1048 14.6995 26.7575 13 30.5662 13H131.091C134.9 13 138.553 14.6995 141.246 17.7247C143.939 20.7498 145.452 24.8528 145.452 29.131V105.753",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2055 105.753V29.131C16.2055 24.8528 17.7185 20.7498 20.4116 17.7247C23.1048 14.6995 26.7575 13 30.5662 13H131.091C134.9 13 138.553 14.6995 141.246 17.7247C143.939 20.7498 145.452 24.8528 145.452 29.131V105.753",
    stroke: "#2B4B8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1 104H55.2045H105.795H160V106.125C160 110.07 157.335 113.854 152.591 116.643C147.847 119.433 141.413 121 134.705 121H26.2955C19.5867 121 13.1527 119.433 8.40887 116.643C3.66505 113.854 1 110.07 1 106.125V104Z",
    fill: "white",
    stroke: "#2B4B8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4461 60.5112C99.4439 59.2522 99.3062 57.9972 99.0352 56.7677L104.966 52.2769L100.596 44.7069L93.7271 47.6047C91.8673 45.8992 89.6596 44.6175 87.2564 43.8481L86.3342 36.4727H77.5929L76.6707 43.8481C74.2674 44.6175 72.0597 45.8992 70.1999 47.6047L63.3315 44.7069L58.9608 52.2769L64.8918 56.7677C64.3444 59.2333 64.3444 61.789 64.8918 64.2546L58.9608 68.7454L63.3315 76.3154L70.1999 73.4177C72.0597 75.1232 74.2674 76.4049 76.6707 77.1742L77.5929 84.5497H86.3342L87.2564 77.1742C89.6596 76.4049 91.8673 75.1232 93.7271 73.4177L100.596 76.3154L104.966 68.7454L99.0352 64.2546C99.3062 63.0252 99.4439 61.7701 99.4461 60.5112V60.5112Z",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9635 63.7881C84.3773 63.7881 86.3341 61.8313 86.3341 59.4175C86.3341 57.0037 84.3773 55.0469 81.9635 55.0469C79.5496 55.0469 77.5928 57.0037 77.5928 59.4175C77.5928 61.8313 79.5496 63.7881 81.9635 63.7881Z",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9635 63.7891V69.2524",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M167.719 121H136.875C133.631 121 131 117.825 131 113.909V50.0909C131 46.175 133.631 43 136.875 43H172.125C175.369 43 178 46.175 178 50.0909V121",
    fill: "#545F6D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M172.719 121H141.875C138.631 121 136 117.825 136 113.909V50.0909C136 46.175 138.631 43 141.875 43H177.125C180.369 43 183 46.175 183 50.0909V121",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M172.719 121H141.875C138.631 121 136 117.825 136 113.909V50.0909C136 46.175 138.631 43 141.875 43H177.125C180.369 43 183 46.175 183 50.0909V121",
    stroke: "#2B4B8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M136 58L183 58",
    stroke: "#2B4B8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M126 104H163",
    stroke: "#2B4B8F",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M175.736 103.599V92.9553C175.736 89.0525 178.929 85.8594 182.832 85.8594C186.735 85.8594 189.928 89.0525 189.928 92.9553V103.599",
    fill: "white"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M175.736 103.599V92.9553C175.736 89.0525 178.929 85.8594 182.832 85.8594C186.735 85.8594 189.928 89.0525 189.928 92.9553V103.599",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M197.024 103.6H168.64V121.339H197.024V103.6Z",
    fill: "white",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.25 89.5833C151.25 84.9808 154.981 81.25 159.583 81.25H161.25C165.852 81.25 169.583 84.9808 169.583 89.5833",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.417 81.25C163.178 81.25 165.417 79.0114 165.417 76.25C165.417 73.4886 163.178 71.25 160.417 71.25C157.655 71.25 155.417 73.4886 155.417 76.25C155.417 79.0114 157.655 81.25 160.417 81.25Z",
    stroke: "#86C2D8",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(150 70)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnable2Fa);
export default __webpack_public_path__ + "static/media/icon-enable2fa.f5bf05accf10eac33b1f3fa61d826a00.svg";
export { ForwardRef as ReactComponent };